/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ShowManagementListSearchResponse } from './ShowManagementListSearchResponse';

export type ShowManagementListSearchResponseApiRespoonse = {
    data?: ShowManagementListSearchResponse;
    status?: ShowManagementListSearchResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ShowManagementListSearchResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

